import ExercisesGrid from './ExercisesGrid'

const ExercisesGridArchive = () => <ExercisesGrid isArchive={true} />

export default ExercisesGridArchive
